export default __webpack_public_path__ + "static/media/render.665a5f51.png";